import { render, staticRenderFns } from "./email-template-edit-page.html?vue&type=template&id=726e5c03&"
import script from "./email-template-edit-page.ts?vue&type=script&lang=ts&"
export * from "./email-template-edit-page.ts?vue&type=script&lang=ts&"
import style0 from "./email-template-edit-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports